import { controller } from "./controller";
import { targets } from "@github/catalyst";

@controller
export default class DataSelectElement extends HTMLElement {
  @targets options: HTMLOptionElement[] | undefined;
  connectedCallback(): void {
    if (this.options) {
      for (const option of this.options) {
        if (option.getAttribute("data-selected")) {
          option.selected = true;
        }
      }
    }
  }
}

declare global {
  interface Window {
    DataSelectElement: typeof DataSelectElement;
  }
  interface HTMLElementTagNameMap {
    "data-select": DataSelectElement;
  }
}

if (!window.customElements.get("data-select")) {
  window.DataSelectElement = DataSelectElement;
  window.customElements.define("data-select", DataSelectElement);
}
